import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, Dumbbell, Tag, Phone, MapPin, Calendar, BookOpen } from 'lucide-react';
import { PageMeta } from '@/components/PageMeta';

const SUGGESTIONS = [
  { to: '/', label: 'Accueil', icon: Home, desc: 'CrossFit Saint-Chamond — HYROX Training Club' },
  { to: '/programmes', label: 'Tous les programmes', icon: Dumbbell, desc: 'WOD CrossFit, HYROX, Team WOD, Free Access' },
  { to: '/tarifs', label: 'Tarifs', icon: Tag, desc: 'À partir de 59€/mois, essai gratuit' },
  { to: '/reservation', label: 'Réserver', icon: Calendar, desc: 'Réserve ta première séance gratuite' },
  { to: '/blog', label: 'Blog', icon: BookOpen, desc: 'Conseils CrossFit, HYROX, nutrition' },
  { to: '/zones-desservies', label: 'Zones desservies', icon: MapPin, desc: 'Saint-Étienne, vallée du Gier, Loire' },
  { to: '/contact', label: 'Contact', icon: Phone, desc: '06 84 28 40 87' },
];

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 py-16">
      <PageMeta
        title="Page introuvable (404) — CrossFit Saint-Chamond"
        description="La page demandée n'existe pas. Découvre nos programmes CrossFit & HYROX, nos tarifs ou réserve directement ta séance d'essai gratuite."
        noindex
      />

      <div className="max-w-3xl w-full text-center" data-testid="not-found-page">
        <div className="text-primary font-semibold text-xs tracking-[0.4em] uppercase mb-3">━━ ERREUR 404</div>
        <h1 className="font-heading text-5xl md:text-6xl text-dark mb-4">
          PAGE <span className="text-gradient-primary italic font-display">INTROUVABLE</span>
        </h1>
        <p className="text-muted-foreground text-base md:text-lg mb-10 max-w-xl mx-auto">
          Cette URL n'existe pas (ou plus). Mais tu n'es pas perdu — voici tout ce qu'il faut pour repartir du bon pied.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10 text-left">
          {SUGGESTIONS.map(({ to, label, icon: Icon, desc }) => (
            <Link
              key={to}
              to={to}
              className="group p-4 rounded-2xl border border-border bg-card hover:border-primary hover:shadow-lg transition-all"
              data-testid={`404-link-${to.replace(/\//g, '')}`}
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                  <Icon className="h-4 w-4" />
                </div>
                <span className="font-heading text-base text-dark">{label}</span>
              </div>
              <p className="text-xs text-muted-foreground">{desc}</p>
            </Link>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="bg-primary hover:bg-primary-light rounded-xl text-white px-6" data-testid="404-home-btn">
              <Home className="h-4 w-4 mr-2" /> Retour à l'accueil
            </Button>
          </Link>
          <a href="tel:+33684284087">
            <Button variant="outline" className="rounded-xl border-primary/40 px-6">
              <Phone className="h-4 w-4 mr-2" /> 06 84 28 40 87
            </Button>
          </a>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 text-xs text-muted-foreground">
          CrossFit Saint-Chamond — 7 Rue Jean-Jacques Rousseau, 42400 Saint-Chamond — HYROX Training Club officiel Loire
        </div>
      </div>
    </div>
  );
}
